import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CSS/Technology.css';

const NewsList = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ header: '', paragraph: '' });

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://weynibirhan.com.et/Technology.php');
      setNewsItems(res.data.data || []);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this news item?')) return;
    try {
      await axios.post('https://weynibirhan.com.et/delete_technology_news.php', { id });
      fetchNews();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const handleEditClick = (item) => {
    setEditItem(item.id);
    setForm({ header: item.header, paragraph: item.paragraph });
  };

  const handleUpdate = async (id) => {
    try {
      await axios.post('https://weynibirhan.com.et/update_technology_news.php', {
        id,
        header: form.header,
        paragraph: form.paragraph,
      });
      setEditItem(null);
      fetchNews();
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  return (
    <div className="news-container">
      <h2>Latest Technology News</h2>
      {loading ? (
        <p>Loading...</p>
      ) : newsItems.length === 0 ? (
        <p>No news available.</p>
      ) : (
        newsItems.map((item) => (
          <div className="news-card" key={item.id}>
            {item.image_url && (
              <img src={`https://weynibirhan.com.et/${item.image_url}`} alt="News" loading="lazy" />
            )}

            {editItem === item.id ? (
              <>
                <input
                  type="text"
                  value={form.header}
                  onChange={(e) => setForm({ ...form, header: e.target.value })}
                />
                <textarea
                  value={form.paragraph}
                  onChange={(e) => setForm({ ...form, paragraph: e.target.value })}
                />
                <button onClick={() => handleUpdate(item.id)}>Save</button>
                <button onClick={() => setEditItem(null)}>Cancel</button>
              </>
            ) : (
              <>
                <h3>{item.header}</h3>
                <p>{item.paragraph}</p>
                <span className="date">
                  {item.created_at ? new Date(item.created_at).toLocaleString() : ''}
                </span>
                <div className="admin-actions">
                  <button onClick={() => handleEditClick(item)}>Edit</button>
                  <button onClick={() => handleDelete(item.id)}>Delete</button>
                </div>
              </>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default NewsList;
